import { useState, type CSSProperties } from 'react';
import { PasscodeGate } from './auth/PasscodeGate';
import { StoryScreen } from './game/StoryScreen';
import { Placement } from './game/Placement';
import { SkillView } from './game/SkillView';
import { BaseView } from './game/BaseView';
import { HomeScreen } from './game/HomeScreen';
import { StoryMap } from './game/StoryMap';
import { useGameStore } from './store/gameStore';

type View = 'home' | 'play' | 'map' | 'base' | 'powers';

export function App() {
  const placementDone = useGameStore((s) => s.placementDone);
  const [view, setView] = useState<View>('home');

  return (
    <PasscodeGate>
      {!placementDone ? (
        <Placement />
      ) : view === 'home' ? (
        <HomeScreen
          onPlay={() => setView('play')}
          onMap={() => setView('map')}
          onBase={() => setView('base')}
          onPowers={() => setView('powers')}
        />
      ) : view === 'map' ? (
        <StoryMap onPlay={() => setView('play')} onClose={() => setView('home')} />
      ) : view === 'base' ? (
        <BaseView onClose={() => setView('home')} />
      ) : view === 'powers' ? (
        <SkillView onClose={() => setView('home')} />
      ) : (
        <>
          <StoryScreen onHome={() => setView('home')} />
          <button type="button" style={homeBtn} onClick={() => setView('home')} aria-label="Home">
            🏠
          </button>
        </>
      )}
    </PasscodeGate>
  );
}

const homeBtn: CSSProperties = {
  position: 'fixed',
  top: 14,
  right: 14,
  zIndex: 30,
  width: 'var(--target-min)',
  height: 'var(--target-min)',
  borderRadius: '50%',
  border: '2px solid var(--gold)',
  background: 'var(--frame-2)',
  fontSize: 26,
  cursor: 'pointer',
};
